{
  "ui": {
    "close": "Close",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "more": "More",
    "retry": "Try again",
    "showMore": "Show more",
    "done": "Done",
    "password": {
      "show": "Show password",
      "hide": "Hide password"
    }
  },
  "preferences": {
    "language": "Language"
  },
  "app": {
    "crash": {
      "title": "Something went wrong",
      "description": "The page didn't finish loading. Reloading it usually helps.",
      "home": "Go to start"
    }
  },
  "notFound": {
    "title": "This page doesn't exist",
    "description": "The link may be outdated or contain a typo.",
    "home": "Go to start"
  },
  "home": {
    "title": "Screenings are by invitation",
    "description": "Open the link your host sent you — it takes you straight to the room.",
    "hostSignIn": "I'm a host — sign in"
  },
  "auth": {
    "login": "Login",
    "password": "Password",
    "signIn": "Sign in",
    "signInTitle": "Host sign-in",
    "signOut": "Sign out",
    "displayName": "Name shown to viewers",
    "newPassword": "Choose a password",
    "welcome": {
      "title": "Welcome to Seans",
      "expires": "This link is valid until {{date}}",
      "submit": "Create account",
      "invalid": "This invitation link doesn't work",
      "invalidHint": "It has been used or has expired. Ask the owner for a new one."
    }
  },
  "validation": {
    "required": "Please fill this in",
    "login": "3 to 32 characters: Latin letters, digits, dot, hyphen, underscore",
    "password": "At least 10 characters",
    "displayName": "1 to 40 characters",
    "title": "1 to 120 characters",
    "trackLabel": "At most 60 characters"
  },
  "roles": {
    "account": {
      "owner": "Owner",
      "host": "Host"
    },
    "participant": {
      "host": "Host",
      "guest": "Viewer"
    }
  },
  "errors": {
    "unauthenticated": "Your session has ended. Please sign in again.",
    "forbidden": "You don't have permission for that.",
    "not_found": "Not found — it may have been deleted.",
    "validation_failed": "Please check what you entered.",
    "rate_limited": "Too many attempts. Wait a while and try again.",
    "credentials_invalid": "Wrong login or password.",
    "account_disabled": "This account's access is turned off. Contact the owner.",
    "login_taken": "This login is already taken.",
    "invitation_invalid": "This invitation is invalid or has expired.",
    "invite_invalid": "This screening link is invalid. Ask your host for a new one.",
    "screening_ended": "This screening has already ended.",
    "participant_banned": "The host has closed this screening to you.",
    "playback_version_conflict": "Someone just controlled the film — showing the current state.",
    "asset_not_ready": "The film is still being processed.",
    "asset_in_use": "The film is used by open screenings — end them first.",
    "track_not_deletable": "This track can't be deleted.",
    "upload_too_large": "The file is too large.",
    "unsupported_subtitle_format": "Please use an SRT, VTT or ASS subtitle file.",
    "realtime_unavailable": "Video calling is unavailable right now. Try again in a minute.",
    "internal": "Server error. Please try again.",
    "network": "Can't reach the server. Check your connection.",
    "timeout": "The server is taking too long. Please try again.",
    "invalid_response": "The server answered unexpectedly. Reload the page.",
    "admission_pending": "The host hasn't let you in yet.",
    "admission_denied": "Your request to join was declined.",
    "admission_decision_conflict": "Someone already decided on this request — the list is refreshed.",
    "unsupported_image_format": "Please use a JPEG, PNG or WebP image."
  },
  "studio": {
    "home": "Seans — studio",
    "account": "Account: {{name}}",
    "nav": {
      "label": "Studio sections",
      "screenings": "Screenings",
      "library": "Films",
      "hosts": "Hosts"
    },
    "profile": {
      "menu": "Profile",
      "title": "Profile",
      "name": "Name shown to viewers",
      "nameHint": "Guests will see the new name the next time they join or refresh the page.",
      "saved": "Name saved"
    }
  },
  "screenings": {
    "create": "New screening",
    "created": "Screening created",
    "saved": "Changes saved",
    "filter": "Which screenings to show",
    "filters": {
      "open": "Upcoming",
      "ended": "Ended"
    },
    "status": {
      "ended": "Ended"
    },
    "openRoom": "Open room",
    "copyLink": "Copy link",
    "linkCopied": "Link copied",
    "empty": {
      "open": "No screenings yet",
      "ended": "No ended screenings",
      "noFilms": "Add a film first"
    },
    "policy": {
      "hosts": "Hosts only",
      "everyone": "Everyone"
    },
    "form": {
      "createTitle": "New screening",
      "editTitle": "Screening",
      "create": "Create",
      "film": "Film",
      "filmPlaceholder": "Choose a film",
      "filmRequired": "Choose a film",
      "filmChangeResets": "The film will start over, paused",
      "title": "Title",
      "titlePlaceholder": "Same as the film",
      "startsAt": "Starts",
      "startsAtRequired": "Enter a date and time",
      "control": "Who controls the film",
      "approval": "Let guests in after approval",
      "approvalOn": "Guests wait until you let them in.",
      "approvalOff": "Anyone with the link enters right away.",
      "approvalOffLetsIn": "Everyone waiting ({{count}}) will be let in when you save."
    },
    "rotate": {
      "action": "New link",
      "title": "Replace the invitation link?",
      "consequence": "The old link stops working. People already in the room stay.",
      "confirm": "Replace",
      "done": "Link replaced — share the new one"
    },
    "end": {
      "action": "End screening",
      "title": "End “{{title}}”?",
      "consequence": "The room closes for everyone: the call and the film stop and the link no longer lets anyone in. This can't be undone.",
      "confirm": "End",
      "done": "Screening ended"
    },
    "delete": {
      "title": "Delete “{{title}}”?",
      "consequence": "The screening and its chat are deleted for good, and the link stops working.",
      "confirm": "Delete",
      "done": "Screening deleted"
    }
  },
  "library": {
    "add": "Add film",
    "empty": "No films in the library yet",
    "title": "Title",
    "resolution": "{{height}}p",
    "status": {
      "awaiting_upload": "Waiting for file",
      "queued": "Queued",
      "processing": "Processing",
      "ready": "Ready",
      "failed": "Failed",
      "withPercent": "{{status}} · {{percent}}%"
    },
    "upload": {
      "start": "Upload",
      "started": "Uploading “{{title}}”",
      "pick": "Choose a video file or drop it here",
      "pickHint": "MKV, MP4, AVI, MOV — any size",
      "fileRequired": "Choose a file",
      "amount": "{{sent}} of {{total}}",
      "uploading": "Uploading · {{percent}}%",
      "paused": "Paused",
      "failed": "Connection lost",
      "pause": "Pause",
      "resume": "Resume",
      "cancel": "Cancel upload",
      "cancelTitle": "Cancel the upload?",
      "cancelConsequence": "The film “{{title}}” and the part of the file already sent will be deleted.",
      "cancelConfirm": "Cancel upload",
      "continue": "Resume",
      "continueTitle": "Resume uploading “{{title}}”",
      "pickAgain": "Choose the same file: {{filename}}",
      "wrongFile": "That's a different file. We need {{filename}}"
    },
    "failure": {
      "upload_incomplete": "The file didn't upload completely.",
      "probe_failed": "The file couldn't be read — it may be damaged.",
      "no_video_stream": "The file has no video.",
      "transcode_failed": "The video couldn't be processed.",
      "subtitle_unsupported": "This subtitle format isn't supported.",
      "subtitle_convert_failed": "The subtitles couldn't be read."
    }
  },
  "asset": {
    "quality": "Quality",
    "noRenditions": "Available after processing",
    "duration": "Length",
    "resolution": "Resolution",
    "size": "File size",
    "added": "Added",
    "file": "Source file",
    "rename": "Rename",
    "renamed": "Title saved",
    "deleteBlocked_one": "Can't delete: used by {{count}} screening",
    "deleteBlocked_few": "Can't delete: used by {{count}} screenings",
    "deleteBlocked_many": "Can't delete: used by {{count}} screenings",
    "deleteBlocked_other": "Can't delete: used by {{count}} screenings",
    "usedBy": "Used by screenings: {{titles}}",
    "missing": "Film not found",
    "delete": {
      "title": "Delete “{{title}}”?",
      "consequence": "The film, its tracks and processed files are deleted for good.",
      "done": "Film deleted"
    },
    "poster": {
      "change": "Change poster",
      "dialogTitle": "New poster",
      "preview": "Poster preview",
      "pick": "Choose an image or drop it here",
      "formats": "{{formats}} · up to {{size}}",
      "tooLarge": "The image is larger than {{size}}.",
      "save": "Save poster",
      "saved": "Poster changed",
      "reset": "Use a frame from the film",
      "resetTitle": "Go back to a frame from the film?",
      "resetConsequence": "Your poster goes away and the film's own frame comes back everywhere — in the studio, invitations and the room.",
      "resetConfirm": "Use the frame",
      "resetDone": "The film's frame is back",
      "source": {
        "frame": "Frame from the film",
        "upload": "Own poster"
      }
    }
  },
  "tracks": {
    "numbered": "Track {{number}}",
    "language": "Language",
    "languageUnset": "Not set",
    "label": "Name",
    "labelOptional": "Name (optional)",
    "default": "Default",
    "defaultHint": "Turns on for viewers automatically",
    "saved": "Track saved",
    "kind": {
      "audio": "Audio tracks",
      "subtitle": "Subtitles"
    },
    "empty": {
      "audio": "The film has no sound",
      "subtitle": "No subtitles yet"
    },
    "status": {
      "processing": "Processing",
      "ready": "Ready",
      "failed": "Failed"
    },
    "delete": {
      "title": "Delete “{{name}}”?",
      "consequence": "Viewers will no longer be able to choose these subtitles.",
      "done": "Subtitles deleted"
    },
    "upload": {
      "title": "Add subtitles",
      "submit": "Upload",
      "pick": "Choose a subtitle file",
      "formats": "{{formats}} · up to {{size}}, any encoding",
      "fileRequired": "Choose a file",
      "tooLarge": "The file is larger than {{size}}",
      "done": "Subtitles uploaded — processing"
    }
  },
  "hosts": {
    "empty": "No hosts yet",
    "you": "you",
    "disabled": "Access off",
    "since": "since {{date}}",
    "noAccess": "This section is for the owner only",
    "noAccessHint": "The studio owner invites hosts and turns their access off.",
    "access": {
      "label": "Access",
      "revoke": "Turn off",
      "revoked": "{{name}} can no longer sign in",
      "restored": "{{name}} can sign in again",
      "revokeTitle": "Turn off access for {{name}}?",
      "revokeConsequence": "{{name}} loses access to the studio and can't sign in until you turn access back on. Screenings and films stay."
    },
    "invite": {
      "action": "Invite",
      "title": "Invite a host",
      "role": "Role",
      "create": "Create link",
      "link": "Invitation link",
      "expires": "Single use, valid until {{date}}",
      "copy": "Copy",
      "copied": "Link copied",
      "copyFailed": "Couldn't copy — select the link by hand"
    }
  },
  "invite": {
    "eyebrow": "You're invited to a screening",
    "name": "Your name",
    "continue": "Continue",
    "asHost": "You'll join as a host — {{name}}",
    "ended": "This screening has already ended.",
    "bannedBadge": "Access closed",
    "invalid": "This screening link doesn't work",
    "invalidHint": "The host may have replaced the link. Ask them for a new one.",
    "askToJoin": "Ask to join"
  },
  "lobby": {
    "eyebrow": "Check before you join",
    "preview": "Camera preview",
    "join": "Join the room",
    "headphones": "With headphones, the film's sound won't reach your microphone.",
    "micLevel": "Microphone level",
    "deviceNumbered": "Device {{number}}",
    "device": {
      "camera": "Camera",
      "microphone": "Microphone",
      "speaker": "Speakers"
    },
    "problem": {
      "denied": "The browser blocked access: {{device}}",
      "notFound": "Device not found: {{device}}. Connect it and press “Try again”.",
      "inUse": "{{device}} is busy in another app (Zoom, Teams, another tab). Close it and press “Try again”.",
      "insecure": "Camera and microphone only work over a secure (https) link.",
      "unsupported": "This browser can't use a camera or microphone. Open the link in Chrome, Safari or Firefox.",
      "unknown": "Couldn't turn on: {{device}}. Press “Try again”."
    },
    "guide": {
      "chrome": "Click the settings icon to the left of the address, turn on Camera and Microphone, then press “Try again”.",
      "edge": "Click the lock next to the address, open “Permissions for this site”, allow camera and microphone, then press “Try again”.",
      "yandex": "Click the lock in the address bar, allow camera and microphone, then press “Try again”.",
      "opera": "Click the lock in the address bar, allow camera and microphone, then press “Try again”.",
      "samsung": "Open the menu → Settings → Sites and downloads → Site permissions, allow camera and microphone, then press “Try again”.",
      "firefox": "Click the crossed-out camera icon in the address bar, remove the block, then press “Try again”.",
      "safari": "Open Safari → Settings for This Website, choose Allow for camera and microphone, then press “Try again”.",
      "safariIos": "Tap “aA” in the address bar → Website Settings, allow camera and microphone, then tap “Try again”.",
      "other": "Allow this site to use your camera and microphone in the browser settings, then press “Try again”."
    }
  },
  "call": {
    "mic": {
      "on": "Turn on microphone",
      "off": "Turn off microphone",
      "onWithHold": "Turn on microphone (or hold Space)",
      "isOff": "Microphone off"
    },
    "camera": {
      "on": "Turn on camera",
      "off": "Turn off camera",
      "isOn": "Camera on"
    },
    "settings": "Devices and sound",
    "deviceProblem": "Device unavailable",
    "pushToTalk": "Hold Space to talk",
    "pushToTalkHint": "While your microphone is off",
    "you": "{{name}} (you)",
    "participants": "Participants",
    "sync": {
      "idle": "Not watching",
      "synced": "In sync",
      "catching_up": "Catching up",
      "buffering": "Loading"
    }
  },
  "player": {
    "label": "Film",
    "notReady": "The film is still being prepared",
    "timeline": "Position in the film",
    "timeOf": "{{position}} of {{duration}}",
    "mute": "Mute",
    "unmute": "Unmute",
    "volume": "Volume",
    "settings": "Viewing settings",
    "subtitles": "Subtitles",
    "subtitlesOff": "Off",
    "audio": "Audio track",
    "quality": "Quality",
    "qualityAuto": "Auto",
    "qualityAutoAt": "Auto · {{height}}p",
    "ducking": "Lower the film while people talk",
    "duckingHint": "Only for you",
    "joinPlayback": "Turn on film and sound",
    "loadFailed": "The film isn't loading.",
    "fullscreen": "Full screen",
    "exitFullscreen": "Exit full screen",
    "play": "Play",
    "pause": "Pause",
    "hostControls": "The host controls the film",
    "start": "Start the film",
    "startsOn": "Starts {{date}}",
    "startsIn": "Starts in {{time}}",
    "waitingForHost": "Starting soon — waiting for the host",
    "poster": "Film poster"
  },
  "moderation": {
    "menu": "Actions: {{name}}",
    "muteMicrophone": "Turn off microphone",
    "muteCamera": "Turn off camera",
    "remove": "Remove from room",
    "ban": "Remove and block",
    "muted": {
      "microphone": "{{name}}'s microphone is off",
      "camera": "{{name}}'s camera is off"
    },
    "removed": "{{name}} is no longer in the room",
    "removeTitle": "Remove {{name}} from the room?",
    "removeConsequence": "{{name}} leaves the room and can come back with the invitation link.",
    "removeConfirm": "Remove",
    "banTitle": "Remove and block {{name}}?",
    "banConsequence": "{{name}} leaves the room and can't return to this screening, not even with the link.",
    "banConfirm": "Remove and block"
  },
  "chat": {
    "label": "Messages",
    "older": "Show earlier",
    "empty": "No messages yet — start the conversation",
    "you": "You",
    "sending": "sending…",
    "failed": "not sent",
    "retry": "Send again",
    "discard": "Remove",
    "message": "Message",
    "placeholder": "Message the room",
    "send": "Send"
  },
  "room": {
    "count_one": "{{count}} participant",
    "count_few": "{{count}} participants",
    "count_many": "{{count}} participants",
    "count_other": "{{count}} participants",
    "leave": "Leave the room",
    "panel": {
      "label": "Chat and people",
      "chat": "Chat",
      "people": "People · {{count}}",
      "hide": "Hide chat",
      "show": "Show chat"
    },
    "connection": {
      "connecting": "Connecting…",
      "reconnecting": "Reconnecting…",
      "unavailable": "No connection"
    },
    "closed": {
      "toInvite": "Back to the invitation",
      "ended": {
        "title": "The screening has ended",
        "description": "Thank you for watching together.",
        "action": "Back to the invitation"
      },
      "removed": {
        "title": "You were removed from the room",
        "description": "You can come back with the same link.",
        "action": "Back to the room"
      },
      "banned": {
        "title": "This screening is closed to you",
        "description": "The host has blocked your access to this screening.",
        "action": "Back to the invitation"
      },
      "left": {
        "title": "You left the room",
        "description": "The film goes on — you can come back any time.",
        "action": "Back to the room"
      },
      "replaced": {
        "title": "The screening is open in another tab",
        "description": "We closed it here so the sound doesn't double.",
        "action": "Watch here"
      },
      "denied": {
        "title": "Your request to join was declined",
        "description": "If this is a mistake, contact the host and check again.",
        "action": "Check again"
      }
    }
  },
  "admission": {
    "welcome": "The host let you in — entering the room",
    "waitingEyebrow": "Waiting to join",
    "waitingTitle": "Waiting for the host to let you in",
    "waitingHint": "The host sees your request. Once they accept it, you'll enter the room by yourself — meanwhile, check your camera and microphone.",
    "waitingSection": "Want to join",
    "refusedSection": "Declined",
    "admit": "Let {{name}} in",
    "admitShort": "Let in",
    "deny": "Decline {{name}}",
    "deniedBy": "Declined by {{name}} · {{when}}",
    "requested": "{{name}} wants to join",
    "dialogTitle": "Requests to join",
    "nobody": "Nobody is waiting",
    "waitingCount": "Waiting: {{count}}"
  }
}
